//#region types
import { AgentCardComponent } from "models/agent/agentContract";
import { KeyValue } from "models/utilTypes/keyValue";
//#endregion

type CardDetail = KeyValue<string | undefined, string>;

// The card's facts, in the order the tree gives them. Card and Column are flattened - only Field
// makes a row - and an unknown component is skipped, so a newer service still renders.
export const cardDetails = (components: AgentCardComponent[]): CardDetail[] => {
  const byId = new Map(components.map((component) => [component.id, component]));
  const root = byId.get("root") ?? components[0];
  const details: CardDetail[] = [];
  const visited = new Set<string>();

  const walk = (component: AgentCardComponent | undefined): void => {
    if (!component || visited.has(component.id)) {
      return;
    }
    visited.add(component.id);

    if (component.component === "Field") {
      if (component.label && component.value) {
        details.push(new KeyValue<string | undefined, string>(component.label, component.value));
      }
      return;
    }

    component.children?.forEach((childId) => walk(byId.get(childId)));
  };

  walk(root);

  return details;
};
